import BackgroundStarsIcon from './BackgroundStarsIcon';

export default BackgroundStarsIcon;
